export default __webpack_public_path__ + "static/media/veuve-cliquot.b16cd72d.png";